//#region lightbox

/*!
 * Lightbox v2.11.2
 * by Lokesh Dhakar
 *
 * More info:
 * http://lokeshdhakar.com/projects/lightbox2/
 *
 * Copyright Lokesh Dhakar
 * Released under the MIT license
 * https://github.com/lokesh/lightbox2/blob/master/LICENSE
 *
 * @preserve
 */
!(function (a, b) {
  'function' == typeof define && define.amd
    ? define(['jquery'], b)
    : 'object' == typeof exports
    ? (module.exports = b(require('jquery')))
    : (a.lightbox = b(a.jQuery));
})(this, function (a) {
  function b(b) {
    (this.album = []),
      (this.currentImageIndex = void 0),
      this.init(),
      (this.options = a.extend({}, this.constructor.defaults)),
      this.option(b);
  }
  return (
    (b.defaults = {
      albumLabel: 'Image %1 of %2',
      alwaysShowNavOnTouchDevices: !1,
      fadeDuration: 600,
      fitImagesInViewport: !0,
      imageFadeDuration: 600,
      positionFromTop: 50,
      resizeDuration: 700,
      showImageNumberLabel: !0,
      wrapAround: !1,
      disableScrolling: !1,
      sanitizeTitle: !1,
    }),
    (b.prototype.option = function (b) {
      a.extend(this.options, b);
    }),
    (b.prototype.imageCountLabel = function (a, b) {
      return this.options.albumLabel.replace(/%1/g, a).replace(/%2/g, b);
    }),
    (b.prototype.init = function () {
      var b = this;
      a(document).ready(function () {
        b.enable(), b.build();
      });
    }),
    (b.prototype.enable = function () {
      var b = this;
      a('body').on(
        'click',
        'a[rel^=lightbox], area[rel^=lightbox], a[data-lightbox], area[data-lightbox]',
        function (c) {
          return b.start(a(c.currentTarget)), !1;
        }
      );
    }),
    (b.prototype.build = function () {
      if (!(a('#lightbox').length > 0)) {
        var b = this;
        a(
          '<div id="lightboxOverlay" tabindex="-1" class="lightboxOverlay"></div><div id="lightbox" tabindex="-1" class="lightbox"><div class="lb-outerContainer"><div class="lb-container"><img class="lb-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="blank pixel"/><div class="lb-nav"><a class="lb-prev" aria-label="Previous image" href="" ></a><a class="lb-next" aria-label="Next image" href="" ></a></div><div class="lb-loader"><a class="lb-cancel"></a></div></div></div><div class="lb-dataContainer"><div class="lb-data"><div class="lb-details"><span class="lb-caption"></span><span class="lb-number"></span></div><div class="lb-closeContainer"><a class="lb-close"></a></div></div></div></div>'
        ).appendTo(a('body')),
          (this.$lightbox = a('#lightbox')),
          (this.$overlay = a('#lightboxOverlay')),
          (this.$outerContainer = this.$lightbox.find('.lb-outerContainer')),
          (this.$container = this.$lightbox.find('.lb-container')),
          (this.$image = this.$lightbox.find('.lb-image')),
          (this.$nav = this.$lightbox.find('.lb-nav')),
          (this.containerPadding = {
            top: parseInt(this.$container.css('padding-top'), 10),
            right: parseInt(this.$container.css('padding-right'), 10),
            bottom: parseInt(this.$container.css('padding-bottom'), 10),
            left: parseInt(this.$container.css('padding-left'), 10),
          }),
          (this.imageBorderWidth = {
            top: parseInt(this.$image.css('border-top-width'), 10),
            right: parseInt(this.$image.css('border-right-width'), 10),
            bottom: parseInt(this.$image.css('border-bottom-width'), 10),
            left: parseInt(this.$image.css('border-left-width'), 10),
          }),
          this.$overlay.hide().on('click', function () {
            return b.end(), !1;
          }),
          this.$lightbox.hide().on('click', function (c) {
            'lightbox' === a(c.target).attr('id') && b.end();
          }),
          this.$outerContainer.on('click', function (c) {
            return 'lightbox' === a(c.target).attr('id') && b.end(), !1;
          }),
          this.$lightbox.find('.lb-prev').on('click', function () {
            return (
              0 === b.currentImageIndex
                ? b.changeImage(b.album.length - 1)
                : b.changeImage(b.currentImageIndex - 1),
              !1
            );
          }),
          this.$lightbox.find('.lb-next').on('click', function () {
            return (
              b.currentImageIndex === b.album.length - 1
                ? b.changeImage(0)
                : b.changeImage(b.currentImageIndex + 1),
              !1
            );
          }),
          this.$nav.on('mousedown', function (a) {
            3 === a.which &&
              (b.$nav.css('pointer-events', 'none'),
              b.$lightbox.one('contextmenu', function () {
                setTimeout(
                  function () {
                    this.$nav.css('pointer-events', 'auto');
                  }.bind(b),
                  0
                );
              }));
          }),
          this.$lightbox.find('.lb-loader, .lb-close').on('click', function () {
            return b.end(), !1;
          });
      }
    }),
    (b.prototype.start = function (b) {
      function c(a) {
        d.album.push({
          alt: a.attr('data-alt'),
          link: a.attr('href'),
          title: a.attr('data-title') || a.attr('title'),
        });
      }
      var d = this,
        e = a(window);
      e.on('resize', a.proxy(this.sizeOverlay, this)),
        this.sizeOverlay(),
        (this.album = []);
      var f,
        g = 0,
        h = b.attr('data-lightbox');
      if (h) {
        f = a(b.prop('tagName') + '[data-lightbox="' + h + '"]');
        for (var i = 0; i < f.length; i = ++i)
          c(a(f[i])), f[i] === b[0] && (g = i);
      } else if ('lightbox' === b.attr('rel')) c(b);
      else {
        f = a(b.prop('tagName') + '[rel="' + b.attr('rel') + '"]');
        for (var j = 0; j < f.length; j = ++j)
          c(a(f[j])), f[j] === b[0] && (g = j);
      }
      var k = e.scrollTop() + this.options.positionFromTop,
        l = e.scrollLeft();
      this.$lightbox
        .css({ top: k + 'px', left: l + 'px' })
        .fadeIn(this.options.fadeDuration),
        this.options.disableScrolling &&
          a('body').addClass('lb-disable-scrolling'),
        this.changeImage(g);
    }),
    (b.prototype.changeImage = function (b) {
      var c = this,
        d = this.album[b].link,
        e = d.split('.').slice(-1)[0],
        f = this.$lightbox.find('.lb-image');
      this.disableKeyboardNav(),
        this.$overlay.fadeIn(this.options.fadeDuration),
        a('.lb-loader').fadeIn('slow'),
        this.$lightbox
          .find(
            '.lb-image, .lb-nav, .lb-prev, .lb-next, .lb-dataContainer, .lb-numbers, .lb-caption'
          )
          .hide(),
        this.$outerContainer.addClass('animating');
      var g = new Image();
      (g.onload = function () {
        var h, i, j, k, l, m;
        f.attr({ alt: c.album[b].alt, src: d }),
          a(g),
          f.width(g.width),
          f.height(g.height),
          (m = a(window).width()),
          (l = a(window).height()),
          (k =
            m -
            c.containerPadding.left -
            c.containerPadding.right -
            c.imageBorderWidth.left -
            c.imageBorderWidth.right -
            20),
          (j =
            l -
            c.containerPadding.top -
            c.containerPadding.bottom -
            c.imageBorderWidth.top -
            c.imageBorderWidth.bottom -
            c.options.positionFromTop -
            70),
          'svg' === e && (f.width(k), f.height(j)),
          c.options.fitImagesInViewport
            ? (c.options.maxWidth &&
                c.options.maxWidth < k &&
                (k = c.options.maxWidth),
              c.options.maxHeight &&
                c.options.maxHeight < j &&
                (j = c.options.maxHeight))
            : ((k = c.options.maxWidth || g.width || k),
              (j = c.options.maxHeight || g.height || j)),
          (g.width > k || g.height > j) &&
            (g.width / k > g.height / j
              ? ((i = k),
                (h = parseInt(g.height / (g.width / i), 10)),
                f.width(i),
                f.height(h))
              : ((h = j),
                (i = parseInt(g.width / (g.height / h), 10)),
                f.width(i),
                f.height(h))),
          c.sizeContainer(f.width(), f.height());
      }),
        (g.src = this.album[b].link),
        (this.currentImageIndex = b);
    }),
    (b.prototype.sizeOverlay = function () {
      var b = this;
      setTimeout(function () {
        b.$overlay.width(a(document).width()).height(a(document).height());
      }, 0);
    }),
    (b.prototype.sizeContainer = function (a, b) {
      function c() {
        d.$lightbox.find('.lb-dataContainer').width(g),
          d.$lightbox.find('.lb-prevLink').height(h),
          d.$lightbox.find('.lb-nextLink').height(h),
          d.$overlay.focus(),
          d.showImage();
      }
      var d = this,
        e = this.$outerContainer.outerWidth(),
        f = this.$outerContainer.outerHeight(),
        g =
          a +
          this.containerPadding.left +
          this.containerPadding.right +
          this.imageBorderWidth.left +
          this.imageBorderWidth.right,
        h =
          b +
          this.containerPadding.top +
          this.containerPadding.bottom +
          this.imageBorderWidth.top +
          this.imageBorderWidth.bottom;
      e !== g || f !== h
        ? this.$outerContainer.animate(
            { width: g, height: h },
            this.options.resizeDuration,
            'swing',
            function () {
              c();
            }
          )
        : c();
    }),
    (b.prototype.showImage = function () {
      this.$lightbox.find('.lb-loader').stop(!0).hide(),
        this.$lightbox.find('.lb-image').fadeIn(this.options.imageFadeDuration),
        this.updateNav(),
        this.updateDetails(),
        this.preloadNeighboringImages(),
        this.enableKeyboardNav();
    }),
    (b.prototype.updateNav = function () {
      var a = !1;
      try {
        document.createEvent('TouchEvent'),
          (a = !!this.options.alwaysShowNavOnTouchDevices);
      } catch (a) {}
      this.$lightbox.find('.lb-nav').show(),
        this.album.length > 1 &&
          (this.options.wrapAround
            ? (a &&
                this.$lightbox.find('.lb-prev, .lb-next').css('opacity', '1'),
              this.$lightbox.find('.lb-prev, .lb-next').show())
            : (this.currentImageIndex > 0 &&
                (this.$lightbox.find('.lb-prev').show(),
                a && this.$lightbox.find('.lb-prev').css('opacity', '1')),
              this.currentImageIndex < this.album.length - 1 &&
                (this.$lightbox.find('.lb-next').show(),
                a && this.$lightbox.find('.lb-next').css('opacity', '1'))));
    }),
    (b.prototype.updateDetails = function () {
      var a = this;
      if (
        void 0 !== this.album[this.currentImageIndex].title &&
        '' !== this.album[this.currentImageIndex].title
      ) {
        var b = this.$lightbox.find('.lb-caption');
        this.options.sanitizeTitle
          ? b.text(this.album[this.currentImageIndex].title)
          : b.html(this.album[this.currentImageIndex].title),
          b.fadeIn('fast');
      }
      if (this.album.length > 1 && this.options.showImageNumberLabel) {
        var c = this.imageCountLabel(
          this.currentImageIndex + 1,
          this.album.length
        );
        this.$lightbox.find('.lb-number').text(c).fadeIn('fast');
      } else this.$lightbox.find('.lb-number').hide();
      this.$outerContainer.removeClass('animating'),
        this.$lightbox
          .find('.lb-dataContainer')
          .fadeIn(this.options.resizeDuration, function () {
            return a.sizeOverlay();
          });
    }),
    (b.prototype.preloadNeighboringImages = function () {
      if (this.album.length > this.currentImageIndex + 1) {
        new Image().src = this.album[this.currentImageIndex + 1].link;
      }
      if (this.currentImageIndex > 0) {
        new Image().src = this.album[this.currentImageIndex - 1].link;
      }
    }),
    (b.prototype.enableKeyboardNav = function () {
      this.$lightbox.on('keyup.keyboard', a.proxy(this.keyboardAction, this)),
        this.$overlay.on('keyup.keyboard', a.proxy(this.keyboardAction, this));
    }),
    (b.prototype.disableKeyboardNav = function () {
      this.$lightbox.off('.keyboard'), this.$overlay.off('.keyboard');
    }),
    (b.prototype.keyboardAction = function (a) {
      var b = a.keyCode;
      27 === b
        ? (a.stopPropagation(), this.end())
        : 37 === b
        ? 0 !== this.currentImageIndex
          ? this.changeImage(this.currentImageIndex - 1)
          : this.options.wrapAround &&
            this.album.length > 1 &&
            this.changeImage(this.album.length - 1)
        : 39 === b &&
          (this.currentImageIndex !== this.album.length - 1
            ? this.changeImage(this.currentImageIndex + 1)
            : this.options.wrapAround &&
              this.album.length > 1 &&
              this.changeImage(0));
    }),
    (b.prototype.end = function () {
      this.disableKeyboardNav(),
        a(window).off('resize', this.sizeOverlay),
        this.$lightbox.fadeOut(this.options.fadeDuration),
        this.$overlay.fadeOut(this.options.fadeDuration),
        this.options.disableScrolling &&
          a('body').removeClass('lb-disable-scrolling');
    }),
    new b()
  );
});
//# sourceMappingURL=lightbox.min.map

//#endregion

//#region cycle 2
/*!
 * jQuery Cycle2; version: 2.1.6 build: 20141007
 * http://jquery.malsup.com/cycle2/
 * Copyright (c) 2014 M. Alsup; Dual licensed: MIT/GPL
 */
!(function (a) {
  'use strict';
  function b(a) {
    return (a || '').toLowerCase();
  }
  var c = '2.1.6';
  (a.fn.cycle = function (c) {
    var d;
    return 0 !== this.length || a.isReady
      ? this.each(function () {
          var d,
            e,
            f,
            g,
            h = a(this),
            i = a.fn.cycle.log;
          if (!h.data('cycle.opts')) {
            (h.data('cycle-log') === !1 ||
              (c && c.log === !1) ||
              (e && e.log === !1)) &&
              (i = a.noop),
              i('--c2 init--'),
              (d = h.data());
            for (var j in d)
              d.hasOwnProperty(j) &&
                /^cycle[A-Z]+/.test(j) &&
                ((g = d[j]),
                (f = j.match(/^cycle(.*)/)[1].replace(/^[A-Z]/, b)),
                i(f + ':', g, '(' + typeof g + ')'),
                (d[f] = g));
            (e = a.extend({}, a.fn.cycle.defaults, d, c || {})),
              (e.timeoutId = 0),
              (e.paused = e.paused || !1),
              (e.container = h),
              (e._maxZ = e.maxZ),
              (e.API = a.extend({ _container: h }, a.fn.cycle.API)),
              (e.API.log = i),
              (e.API.trigger = function (a, b) {
                return e.container.trigger(a, b), e.API;
              }),
              h.data('cycle.opts', e),
              h.data('cycle.API', e.API),
              e.API.trigger('cycle-bootstrap', [e, e.API]),
              e.API.addInitialSlides(),
              e.API.preInitSlideshow(),
              e.slides.length && e.API.initSlideshow();
          }
        })
      : ((d = { s: this.selector, c: this.context }),
        a.fn.cycle.log('requeuing slideshow (dom not ready)'),
        a(function () {
          a(d.s, d.c).cycle(c);
        }),
        this);
  }),
    (a.fn.cycle.API = {
      opts: function () {
        return this._container.data('cycle.opts');
      },
      addInitialSlides: function () {
        var b = this.opts(),
          c = b.slides;
        (b.slideCount = 0),
          (b.slides = a()),
          (c = c.jquery ? c : b.container.find(c)),
          b.random &&
            c.sort(function () {
              return Math.random() - 0.5;
            }),
          b.API.add(c);
      },
      preInitSlideshow: function () {
        var b = this.opts();
        b.API.trigger('cycle-pre-initialize', [b]);
        var c = a.fn.cycle.transitions[b.fx];
        c && a.isFunction(c.preInit) && c.preInit(b), (b._preInitialized = !0);
      },
      postInitSlideshow: function () {
        var b = this.opts();
        b.API.trigger('cycle-post-initialize', [b]);
        var c = a.fn.cycle.transitions[b.fx];
        c && a.isFunction(c.postInit) && c.postInit(b);
      },
      initSlideshow: function () {
        var b,
          c = this.opts(),
          d = c.container;
        c.API.calcFirstSlide(),
          'static' == c.container.css('position') &&
            c.container.css('position', 'relative'),
          a(c.slides[c.currSlide]).css({
            opacity: 1,
            display: 'block',
            visibility: 'visible',
          }),
          c.API.stackSlides(
            c.slides[c.currSlide],
            c.slides[c.nextSlide],
            !c.reverse
          ),
          c.pauseOnHover &&
            (c.pauseOnHover !== !0 && (d = a(c.pauseOnHover)),
            d.hover(
              function () {
                c.API.pause(!0);
              },
              function () {
                c.API.resume(!0);
              }
            )),
          c.timeout &&
            ((b = c.API.getSlideOpts(c.currSlide)),
            c.API.queueTransition(b, b.timeout + c.delay)),
          (c._initialized = !0),
          c.API.updateView(!0),
          c.API.trigger('cycle-initialized', [c]),
          c.API.postInitSlideshow();
      },
      pause: function (b) {
        var c = this.opts(),
          d = c.API.getSlideOpts(),
          e = c.hoverPaused || c.paused;
        b ? (c.hoverPaused = !0) : (c.paused = !0),
          e ||
            (c.container.addClass('cycle-paused'),
            c.API.trigger('cycle-paused', [c]).log('cycle-paused'),
            d.timeout &&
              (clearTimeout(c.timeoutId),
              (c.timeoutId = 0),
              (c._remainingTimeout -= a.now() - c._lastQueue),
              (c._remainingTimeout < 0 || isNaN(c._remainingTimeout)) &&
                (c._remainingTimeout = void 0)));
      },
      resume: function (a) {
        var b = this.opts(),
          c = !b.hoverPaused && !b.paused;
        a ? (b.hoverPaused = !1) : (b.paused = !1),
          c ||
            (b.container.removeClass('cycle-paused'),
            0 === b.slides.filter(':animated').length &&
              b.API.queueTransition(b.API.getSlideOpts(), b._remainingTimeout),
            b.API.trigger('cycle-resumed', [b, b._remainingTimeout]).log(
              'cycle-resumed'
            ));
      },
      add: function (b, c) {
        var d,
          e = this.opts(),
          f = e.slideCount,
          g = !1;
        'string' == a.type(b) && (b = a.trim(b)),
          a(b).each(function () {
            var b,
              d = a(this);
            c ? e.container.prepend(d) : e.container.append(d),
              e.slideCount++,
              (b = e.API.buildSlideOpts(d)),
              (e.slides = c ? a(d).add(e.slides) : e.slides.add(d)),
              e.API.initSlide(b, d, --e._maxZ),
              d.data('cycle.opts', b),
              e.API.trigger('cycle-slide-added', [e, b, d]);
          }),
          e.API.updateView(!0),
          (g = e._preInitialized && 2 > f && e.slideCount >= 1),
          g &&
            (e._initialized
              ? e.timeout &&
                ((d = e.slides.length),
                (e.nextSlide = e.reverse ? d - 1 : 1),
                e.timeoutId || e.API.queueTransition(e))
              : e.API.initSlideshow());
      },
      calcFirstSlide: function () {
        var a,
          b = this.opts();
        (a = parseInt(b.startingSlide || 0, 10)),
          (a >= b.slides.length || 0 > a) && (a = 0),
          (b.currSlide = a),
          b.reverse
            ? ((b.nextSlide = a - 1),
              b.nextSlide < 0 && (b.nextSlide = b.slides.length - 1))
            : ((b.nextSlide = a + 1),
              b.nextSlide == b.slides.length && (b.nextSlide = 0));
      },
      calcNextSlide: function () {
        var a,
          b = this.opts();
        b.reverse
          ? ((a = b.nextSlide - 1 < 0),
            (b.nextSlide = a ? b.slideCount - 1 : b.nextSlide - 1),
            (b.currSlide = a ? 0 : b.nextSlide + 1))
          : ((a = b.nextSlide + 1 == b.slides.length),
            (b.nextSlide = a ? 0 : b.nextSlide + 1),
            (b.currSlide = a ? b.slides.length - 1 : b.nextSlide - 1));
      },
      calcTx: function (b, c) {
        var d,
          e = b;
        return (
          e._tempFx
            ? (d = a.fn.cycle.transitions[e._tempFx])
            : c && e.manualFx && (d = a.fn.cycle.transitions[e.manualFx]),
          d || (d = a.fn.cycle.transitions[e.fx]),
          (e._tempFx = null),
          (this.opts()._tempFx = null),
          d ||
            ((d = a.fn.cycle.transitions.fade),
            e.API.log('Transition "' + e.fx + '" not found.  Using fade.')),
          d
        );
      },
      prepareTx: function (a, b) {
        var c,
          d,
          e,
          f,
          g,
          h = this.opts();
        return h.slideCount < 2
          ? void (h.timeoutId = 0)
          : (!a ||
              (h.busy && !h.manualTrump) ||
              (h.API.stopTransition(),
              (h.busy = !1),
              clearTimeout(h.timeoutId),
              (h.timeoutId = 0)),
            void (
              h.busy ||
              ((0 !== h.timeoutId || a) &&
                ((d = h.slides[h.currSlide]),
                (e = h.slides[h.nextSlide]),
                (f = h.API.getSlideOpts(h.nextSlide)),
                (g = h.API.calcTx(f, a)),
                (h._tx = g),
                a && void 0 !== f.manualSpeed && (f.speed = f.manualSpeed),
                h.nextSlide != h.currSlide &&
                (a || (!h.paused && !h.hoverPaused && h.timeout))
                  ? (h.API.trigger('cycle-before', [f, d, e, b]),
                    g.before && g.before(f, d, e, b),
                    (c = function () {
                      (h.busy = !1),
                        h.container.data('cycle.opts') &&
                          (g.after && g.after(f, d, e, b),
                          h.API.trigger('cycle-after', [f, d, e, b]),
                          h.API.queueTransition(f),
                          h.API.updateView(!0));
                    }),
                    (h.busy = !0),
                    g.transition
                      ? g.transition(f, d, e, b, c)
                      : h.API.doTransition(f, d, e, b, c),
                    h.API.calcNextSlide(),
                    h.API.updateView())
                  : h.API.queueTransition(f)))
            ));
      },
      doTransition: function (b, c, d, e, f) {
        var g = b,
          h = a(c),
          i = a(d),
          j = function () {
            i.animate(
              g.animIn || { opacity: 1 },
              g.speed,
              g.easeIn || g.easing,
              f
            );
          };
        i.css(g.cssBefore || {}),
          h.animate(
            g.animOut || {},
            g.speed,
            g.easeOut || g.easing,
            function () {
              h.css(g.cssAfter || {}), g.sync || j();
            }
          ),
          g.sync && j();
      },
      queueTransition: function (b, c) {
        var d = this.opts(),
          e = void 0 !== c ? c : b.timeout;
        return 0 === d.nextSlide && 0 === --d.loop
          ? (d.API.log('terminating; loop=0'),
            (d.timeout = 0),
            e
              ? setTimeout(function () {
                  d.API.trigger('cycle-finished', [d]);
                }, e)
              : d.API.trigger('cycle-finished', [d]),
            void (d.nextSlide = d.currSlide))
          : void 0 !== d.continueAuto &&
            (d.continueAuto === !1 ||
              (a.isFunction(d.continueAuto) && d.continueAuto() === !1))
          ? (d.API.log('terminating automatic transitions'),
            (d.timeout = 0),
            void (d.timeoutId && clearTimeout(d.timeoutId)))
          : void (
              e &&
              ((d._lastQueue = a.now()),
              void 0 === c && (d._remainingTimeout = b.timeout),
              d.paused ||
                d.hoverPaused ||
                (d.timeoutId = setTimeout(function () {
                  d.API.prepareTx(!1, !d.reverse);
                }, e)))
            );
      },
      stopTransition: function () {
        var a = this.opts();
        a.slides.filter(':animated').length &&
          (a.slides.stop(!1, !0),
          a.API.trigger('cycle-transition-stopped', [a])),
          a._tx && a._tx.stopTransition && a._tx.stopTransition(a);
      },
      advanceSlide: function (a) {
        var b = this.opts();
        return (
          clearTimeout(b.timeoutId),
          (b.timeoutId = 0),
          (b.nextSlide = b.currSlide + a),
          b.nextSlide < 0
            ? (b.nextSlide = b.slides.length - 1)
            : b.nextSlide >= b.slides.length && (b.nextSlide = 0),
          b.API.prepareTx(!0, a >= 0),
          !1
        );
      },
      buildSlideOpts: function (c) {
        var d,
          e,
          f = this.opts(),
          g = c.data() || {};
        for (var h in g)
          g.hasOwnProperty(h) &&
            /^cycle[A-Z]+/.test(h) &&
            ((d = g[h]),
            (e = h.match(/^cycle(.*)/)[1].replace(/^[A-Z]/, b)),
            f.API.log(
              '[' + (f.slideCount - 1) + ']',
              e + ':',
              d,
              '(' + typeof d + ')'
            ),
            (g[e] = d));
        (g = a.extend({}, a.fn.cycle.defaults, f, g)),
          (g.slideNum = f.slideCount);
        try {
          delete g.API,
            delete g.slideCount,
            delete g.currSlide,
            delete g.nextSlide,
            delete g.slides;
        } catch (i) {}
        return g;
      },
      getSlideOpts: function (b) {
        var c = this.opts();
        void 0 === b && (b = c.currSlide);
        var d = c.slides[b],
          e = a(d).data('cycle.opts');
        return a.extend({}, c, e);
      },
      initSlide: function (b, c, d) {
        var e = this.opts();
        c.css(b.slideCss || {}),
          d > 0 && c.css('zIndex', d),
          isNaN(b.speed) &&
            (b.speed = a.fx.speeds[b.speed] || a.fx.speeds._default),
          b.sync || (b.speed = b.speed / 2),
          c.addClass(e.slideClass);
      },
      updateView: function (a, b) {
        var c = this.opts();
        if (c._initialized) {
          var d = c.API.getSlideOpts(),
            e = c.slides[c.currSlide];
          (!a &&
            b !== !0 &&
            (c.API.trigger('cycle-update-view-before', [c, d, e]),
            c.updateView < 0)) ||
            (c.slideActiveClass &&
              c.slides
                .removeClass(c.slideActiveClass)
                .eq(c.currSlide)
                .addClass(c.slideActiveClass),
            a &&
              c.hideNonActive &&
              c.slides
                .filter(':not(.' + c.slideActiveClass + ')')
                .css('visibility', 'hidden'),
            0 === c.updateView &&
              setTimeout(function () {
                c.API.trigger('cycle-update-view', [c, d, e, a]);
              }, d.speed / (c.sync ? 2 : 1)),
            0 !== c.updateView &&
              c.API.trigger('cycle-update-view', [c, d, e, a]),
            a && c.API.trigger('cycle-update-view-after', [c, d, e]));
        }
      },
      getComponent: function (b) {
        var c = this.opts(),
          d = c[b];
        return 'string' == typeof d
          ? /^\s*[\>|\+|~]/.test(d)
            ? c.container.find(d)
            : a(d)
          : d.jquery
          ? d
          : a(d);
      },
      stackSlides: function (b, c, d) {
        var e = this.opts();
        b ||
          ((b = e.slides[e.currSlide]),
          (c = e.slides[e.nextSlide]),
          (d = !e.reverse)),
          a(b).css('zIndex', e.maxZ);
        var f,
          g = e.maxZ - 2,
          h = e.slideCount;
        if (d) {
          for (f = e.currSlide + 1; h > f; f++)
            a(e.slides[f]).css('zIndex', g--);
          for (f = 0; f < e.currSlide; f++) a(e.slides[f]).css('zIndex', g--);
        } else {
          for (f = e.currSlide - 1; f >= 0; f--)
            a(e.slides[f]).css('zIndex', g--);
          for (f = h - 1; f > e.currSlide; f--)
            a(e.slides[f]).css('zIndex', g--);
        }
        a(c).css('zIndex', e.maxZ - 1);
      },
      getSlideIndex: function (a) {
        return this.opts().slides.index(a);
      },
    }),
    (a.fn.cycle.log = function () {
      window.console &&
        console.log &&
        console.log('[cycle2] ' + Array.prototype.join.call(arguments, ' '));
    }),
    (a.fn.cycle.version = function () {
      return 'Cycle2: ' + c;
    }),
    (a.fn.cycle.transitions = {
      custom: {},
      none: {
        before: function (a, b, c, d) {
          a.API.stackSlides(c, b, d),
            (a.cssBefore = {
              opacity: 1,
              visibility: 'visible',
              display: 'block',
            });
        },
      },
      fade: {
        before: function (b, c, d, e) {
          var f = b.API.getSlideOpts(b.nextSlide).slideCss || {};
          b.API.stackSlides(c, d, e),
            (b.cssBefore = a.extend(f, {
              opacity: 0,
              visibility: 'visible',
              display: 'block',
            })),
            (b.animIn = { opacity: 1 }),
            (b.animOut = { opacity: 0 });
        },
      },
      fadeout: {
        before: function (b, c, d, e) {
          var f = b.API.getSlideOpts(b.nextSlide).slideCss || {};
          b.API.stackSlides(c, d, e),
            (b.cssBefore = a.extend(f, {
              opacity: 1,
              visibility: 'visible',
              display: 'block',
            })),
            (b.animOut = { opacity: 0 });
        },
      },
      scrollHorz: {
        before: function (a, b, c, d) {
          a.API.stackSlides(b, c, d);
          var e = a.container.css('overflow', 'hidden').width();
          (a.cssBefore = {
            left: d ? e : -e,
            top: 0,
            opacity: 1,
            visibility: 'visible',
            display: 'block',
          }),
            (a.cssAfter = { zIndex: a._maxZ - 2, left: 0 }),
            (a.animIn = { left: 0 }),
            (a.animOut = { left: d ? -e : e });
        },
      },
    }),
    (a.fn.cycle.defaults = {
      allowWrap: !0,
      autoSelector: '.cycle-slideshow[data-cycle-auto-init!=false]',
      delay: 0,
      easing: null,
      fx: 'fade',
      hideNonActive: !0,
      loop: 0,
      manualFx: void 0,
      manualSpeed: void 0,
      manualTrump: !0,
      maxZ: 100,
      pauseOnHover: !1,
      reverse: !1,
      slideActiveClass: 'cycle-slide-active',
      slideClass: 'cycle-slide',
      slideCss: { position: 'absolute', top: 0, left: 0 },
      slides: '> img',
      speed: 500,
      startingSlide: 0,
      sync: !0,
      timeout: 4e3,
      updateView: 0,
    }),
    a(document).ready(function () {
      a(a.fn.cycle.defaults.autoSelector).cycle();
    });
})(
  jQuery
) /*! Cycle2 autoheight plugin; Copyright (c) M.Alsup, 2012; version: 20130913 */,
  (function (a) {
    'use strict';
    function b(b, d) {
      var e,
        f,
        g,
        h = d.autoHeight;
      if ('container' == h)
        (f = a(d.slides[d.currSlide]).outerHeight()), d.container.height(f);
      else if (d._autoHeightRatio)
        d.container.height(d.container.width() / d._autoHeightRatio);
      else if ('calc' === h || ('number' == a.type(h) && h >= 0)) {
        if (
          ((g = 'calc' === h ? c(b, d) : h >= d.slides.length ? 0 : h),
          g == d._sentinelIndex)
        )
          return;
        (d._sentinelIndex = g),
          d._sentinel && d._sentinel.remove(),
          (e = a(d.slides[g].cloneNode(!0))),
          e
            .removeAttr('id name rel')
            .find('[id],[name],[rel]')
            .removeAttr('id name rel'),
          e
            .css({ position: 'static', visibility: 'hidden', display: 'block' })
            .prependTo(d.container)
            .addClass('cycle-sentinel cycle-slide')
            .removeClass('cycle-slide-active'),
          e.find('*').css('visibility', 'hidden'),
          (d._sentinel = e);
      }
    }
    function c(b, c) {
      var d = 0,
        e = -1;
      return (
        c.slides.each(function (b) {
          var c = a(this).height();
          c > e && ((e = c), (d = b));
        }),
        d
      );
    }
    function d(b, c, d, e) {
      var f = a(e).outerHeight();
      c.container.animate({ height: f }, c.autoHeightSpeed, c.autoHeightEasing);
    }
    function e(c, f) {
      f._autoHeightOnResize &&
        (a(window).off('resize orientationchange', f._autoHeightOnResize),
        (f._autoHeightOnResize = null)),
        f.container.off('cycle-slide-added cycle-slide-removed', b),
        f.container.off('cycle-destroyed', e),
        f.container.off('cycle-before', d),
        f._sentinel && (f._sentinel.remove(), (f._sentinel = null));
    }
    a.extend(a.fn.cycle.defaults, {
      autoHeight: 0,
      autoHeightSpeed: 250,
      autoHeightEasing: null,
    }),
      a(document).on('cycle-initialized', function (c, f) {
        function g() {
          b(c, f);
        }
        var h,
          i = f.autoHeight,
          j = a.type(i),
          k = null;
        ('string' === j || 'number' === j) &&
          (f.container.on('cycle-slide-added cycle-slide-removed', b),
          f.container.on('cycle-destroyed', e),
          'container' == i
            ? f.container.on('cycle-before', d)
            : 'string' === j &&
              /\d+\:\d+/.test(i) &&
              ((h = i.match(/(\d+)\:(\d+)/)),
              (h = h[1] / h[2]),
              (f._autoHeightRatio = h)),
          'number' !== j &&
            ((f._autoHeightOnResize = function () {
              clearTimeout(k), (k = setTimeout(g, 50));
            }),
            a(window).on('resize orientationchange', f._autoHeightOnResize)),
          setTimeout(g, 30));
      });
  })(jQuery) /*! caption plugin for Cycle2;  version: 20130306 */,
  (function (a) {
    'use strict';
    a.extend(a.fn.cycle.defaults, {
      caption: '> .cycle-caption',
      captionTemplate: '{{slideNum}} / {{slideCount}}',
      overlay: '> .cycle-overlay',
      overlayTemplate: '<div>{{title}}</div><div>{{desc}}</div>',
      captionModule: 'caption',
    }),
      a(document).on('cycle-update-view', function (b, c, d, e) {
        if ('caption' === c.captionModule) {
          a.each(['caption', 'overlay'], function () {
            var a = this,
              b = d[a + 'Template'],
              f = c.API.getComponent(a);
            f.length && b
              ? (f.html(c.API.tmpl(b, d, c, e)), f.show())
              : f.hide();
          });
        }
      }),
      a(document).on('cycle-destroyed', function (b, c) {
        var d;
        a.each(['caption', 'overlay'], function () {
          var a = this,
            b = c[a + 'Template'];
          c[a] && b && ((d = c.API.getComponent('caption')), d.empty());
        });
      });
  })(jQuery) /*! command plugin for Cycle2;  version: 20140415 */,
  (function (a) {
    'use strict';
    var b = a.fn.cycle;
    (a.fn.cycle = function (c) {
      var d,
        e,
        f,
        g = a.makeArray(arguments);
      return 'number' == a.type(c)
        ? this.cycle('goto', c)
        : 'string' == a.type(c)
        ? this.each(function () {
            var h;
            return (
              (d = c),
              (f = a(this).data('cycle.opts')),
              void 0 === f
                ? void b.log(
                    'slideshow must be initialized before sending commands; "' +
                      d +
                      '" ignored'
                  )
                : ((d = 'goto' == d ? 'jump' : d),
                  (e = f.API[d]),
                  a.isFunction(e)
                    ? ((h = a.makeArray(g)), h.shift(), e.apply(f.API, h))
                    : void b.log('unknown command: ', d))
            );
          })
        : b.apply(this, arguments);
    }),
      a.extend(a.fn.cycle, b),
      a.extend(b.API, {
        next: function () {
          var a = this.opts();
          if (!a.busy || a.manualTrump) {
            var b = a.reverse ? -1 : 1;
            (a.allowWrap === !1 && a.currSlide + b >= a.slideCount) ||
              (a.API.advanceSlide(b),
              a.API.trigger('cycle-next', [a]).log('cycle-next'));
          }
        },
        prev: function () {
          var a = this.opts();
          if (!a.busy || a.manualTrump) {
            var b = a.reverse ? 1 : -1;
            (a.allowWrap === !1 && a.currSlide + b < 0) ||
              (a.API.advanceSlide(b),
              a.API.trigger('cycle-prev', [a]).log('cycle-prev'));
          }
        },
        destroy: function () {
          this.stop();
          var b = this.opts(),
            c = a.isFunction(a._data) ? a._data : a.noop;
          clearTimeout(b.timeoutId),
            (b.timeoutId = 0),
            b.API.stop(),
            b.API.trigger('cycle-destroyed', [b]).log('cycle-destroyed'),
            b.container.removeData(),
            c(b.container[0], 'parsedAttrs', !1),
            b.retainStylesOnDestroy ||
              (b.container.removeAttr('style'),
              b.slides.removeAttr('style'),
              b.slides.removeClass(b.slideActiveClass)),
            b.slides.each(function () {
              var d = a(this);
              d.removeData(),
                d.removeClass(b.slideClass),
                c(this, 'parsedAttrs', !1);
            });
        },
        jump: function (a, b) {
          var c,
            d = this.opts();
          if (!d.busy || d.manualTrump) {
            var e = parseInt(a, 10);
            if (isNaN(e) || 0 > e || e >= d.slides.length)
              return void d.API.log('goto: invalid slide index: ' + e);
            if (e == d.currSlide)
              return void d.API.log('goto: skipping, already on slide', e);
            (d.nextSlide = e),
              clearTimeout(d.timeoutId),
              (d.timeoutId = 0),
              d.API.log('goto: ', e, ' (zero-index)'),
              (c = d.currSlide < d.nextSlide),
              (d._tempFx = b),
              d.API.prepareTx(!0, c);
          }
        },
        stop: function () {
          var b = this.opts(),
            c = b.container;
          clearTimeout(b.timeoutId),
            (b.timeoutId = 0),
            b.API.stopTransition(),
            b.pauseOnHover &&
              (b.pauseOnHover !== !0 && (c = a(b.pauseOnHover)),
              c.off('mouseenter mouseleave')),
            b.API.trigger('cycle-stopped', [b]).log('cycle-stopped');
        },
        reinit: function () {
          var a = this.opts();
          a.API.destroy(), a.container.cycle();
        },
        remove: function (b) {
          for (
            var c, d, e = this.opts(), f = [], g = 1, h = 0;
            h < e.slides.length;
            h++
          )
            (c = e.slides[h]),
              h == b
                ? (d = c)
                : (f.push(c), (a(c).data('cycle.opts').slideNum = g), g++);
          d &&
            ((e.slides = a(f)),
            e.slideCount--,
            a(d).remove(),
            b == e.currSlide
              ? e.API.advanceSlide(1)
              : b < e.currSlide
              ? e.currSlide--
              : e.currSlide++,
            e.API.trigger('cycle-slide-removed', [e, b, d]).log(
              'cycle-slide-removed'
            ),
            e.API.updateView());
        },
      }),
      a(document).on('click.cycle', '[data-cycle-cmd]', function (b) {
        b.preventDefault();
        var c = a(this),
          d = c.data('cycle-cmd'),
          e = c.data('cycle-context') || '.cycle-slideshow';
        a(e).cycle(d, c.data('cycle-arg'));
      });
  })(jQuery) /*! hash plugin for Cycle2;  version: 20130905 */,
  (function (a) {
    'use strict';
    function b(b, c) {
      var d;
      return b._hashFence
        ? void (b._hashFence = !1)
        : ((d = window.location.hash.substring(1)),
          void b.slides.each(function (e) {
            if (a(this).data('cycle-hash') == d) {
              if (c === !0) b.startingSlide = e;
              else {
                var f = b.currSlide < e;
                (b.nextSlide = e), b.API.prepareTx(!0, f);
              }
              return !1;
            }
          }));
    }
    a(document).on('cycle-pre-initialize', function (c, d) {
      b(d, !0),
        (d._onHashChange = function () {
          b(d, !1);
        }),
        a(window).on('hashchange', d._onHashChange);
    }),
      a(document).on('cycle-update-view', function (a, b, c) {
        c.hash &&
          '#' + c.hash != window.location.hash &&
          ((b._hashFence = !0), (window.location.hash = c.hash));
      }),
      a(document).on('cycle-destroyed', function (b, c) {
        c._onHashChange && a(window).off('hashchange', c._onHashChange);
      });
  })(jQuery) /*! loader plugin for Cycle2;  version: 20131121 */,
  (function (a) {
    'use strict';
    a.extend(a.fn.cycle.defaults, { loader: !1 }),
      a(document).on('cycle-bootstrap', function (b, c) {
        function d(b, d) {
          function f(b) {
            var f;
            'wait' == c.loader
              ? (h.push(b),
                0 === j &&
                  (h.sort(g),
                  e.apply(c.API, [h, d]),
                  c.container.removeClass('cycle-loading')))
              : ((f = a(c.slides[c.currSlide])),
                e.apply(c.API, [b, d]),
                f.show(),
                c.container.removeClass('cycle-loading'));
          }
          function g(a, b) {
            return a.data('index') - b.data('index');
          }
          var h = [];
          if ('string' == a.type(b)) b = a.trim(b);
          else if ('array' === a.type(b))
            for (var i = 0; i < b.length; i++) b[i] = a(b[i])[0];
          b = a(b);
          var j = b.length;
          j &&
            (b
              .css('visibility', 'hidden')
              .appendTo('body')
              .each(function (b) {
                function g() {
                  0 === --i && (--j, f(k));
                }
                var i = 0,
                  k = a(this),
                  l = k.is('img') ? k : k.find('img');
                return (
                  k.data('index', b),
                  (l = l
                    .filter(':not(.cycle-loader-ignore)')
                    .filter(':not([src=""])')),
                  l.length
                    ? ((i = l.length),
                      void l.each(function () {
                        this.complete
                          ? g()
                          : a(this)
                              .load(function () {
                                g();
                              })
                              .on('error', function () {
                                0 === --i &&
                                  (c.API.log(
                                    'slide skipped; img not loaded:',
                                    this.src
                                  ),
                                  0 === --j &&
                                    'wait' == c.loader &&
                                    e.apply(c.API, [h, d]));
                              });
                      }))
                    : (--j, void h.push(k))
                );
              }),
            j && c.container.addClass('cycle-loading'));
        }
        var e;
        c.loader && ((e = c.API.add), (c.API.add = d));
      });
  })(jQuery) /*! pager plugin for Cycle2;  version: 20140415 */,
  (function (a) {
    'use strict';
    function b(b, c, d) {
      var e,
        f = b.API.getComponent('pager');
      f.each(function () {
        var f = a(this);
        if (c.pagerTemplate) {
          var g = b.API.tmpl(c.pagerTemplate, c, b, d[0]);
          e = a(g).appendTo(f);
        } else e = f.children().eq(b.slideCount - 1);
        e.on(b.pagerEvent, function (a) {
          b.pagerEventBubble || a.preventDefault(),
            b.API.page(f, a.currentTarget);
        });
      });
    }
    function c(a, b) {
      var c = this.opts();
      if (!c.busy || c.manualTrump) {
        var d = a.children().index(b),
          e = d,
          f = c.currSlide < e;
        c.currSlide != e &&
          ((c.nextSlide = e),
          (c._tempFx = c.pagerFx),
          c.API.prepareTx(!0, f),
          c.API.trigger('cycle-pager-activated', [c, a, b]));
      }
    }
    a.extend(a.fn.cycle.defaults, {
      pager: '> .cycle-pager',
      pagerActiveClass: 'cycle-pager-active',
      pagerEvent: 'click.cycle',
      pagerEventBubble: void 0,
      pagerTemplate: '<span>&bull;</span>',
    }),
      a(document).on('cycle-bootstrap', function (a, c, d) {
        d.buildPagerLink = b;
      }),
      a(document).on('cycle-slide-added', function (a, b, d, e) {
        b.pager && (b.API.buildPagerLink(b, d, e), (b.API.page = c));
      }),
      a(document).on('cycle-slide-removed', function (b, c, d) {
        if (c.pager) {
          var e = c.API.getComponent('pager');
          e.each(function () {
            var b = a(this);
            a(b.children()[d]).remove();
          });
        }
      }),
      a(document).on('cycle-update-view', function (b, c) {
        var d;
        c.pager &&
          ((d = c.API.getComponent('pager')),
          d.each(function () {
            a(this)
              .children()
              .removeClass(c.pagerActiveClass)
              .eq(c.currSlide)
              .addClass(c.pagerActiveClass);
          }));
      }),
      a(document).on('cycle-destroyed', function (a, b) {
        var c = b.API.getComponent('pager');
        c && (c.children().off(b.pagerEvent), b.pagerTemplate && c.empty());
      });
  })(jQuery) /*! prevnext plugin for Cycle2;  version: 20140408 */,
  (function (a) {
    'use strict';
    a.extend(a.fn.cycle.defaults, {
      next: '> .cycle-next',
      nextEvent: 'click.cycle',
      disabledClass: 'disabled',
      prev: '> .cycle-prev',
      prevEvent: 'click.cycle',
      swipe: !1,
    }),
      a(document).on('cycle-initialized', function (a, b) {
        if (
          (b.API.getComponent('next').on(b.nextEvent, function (a) {
            a.preventDefault(), b.API.next();
          }),
          b.API.getComponent('prev').on(b.prevEvent, function (a) {
            a.preventDefault(), b.API.prev();
          }),
          b.swipe)
        ) {
          var c = b.swipeVert
              ? 'swipeUp.cycle'
              : 'swipeLeft.cycle swipeleft.cycle',
            d = b.swipeVert
              ? 'swipeDown.cycle'
              : 'swipeRight.cycle swiperight.cycle';
          b.container.on(c, function () {
            (b._tempFx = b.swipeFx), b.API.next();
          }),
            b.container.on(d, function () {
              (b._tempFx = b.swipeFx), b.API.prev();
            });
        }
      }),
      a(document).on('cycle-update-view', function (a, b) {
        if (!b.allowWrap) {
          var c = b.disabledClass,
            d = b.API.getComponent('next'),
            e = b.API.getComponent('prev'),
            f = b._prevBoundry || 0,
            g = void 0 !== b._nextBoundry ? b._nextBoundry : b.slideCount - 1;
          b.currSlide == g
            ? d.addClass(c).prop('disabled', !0)
            : d.removeClass(c).prop('disabled', !1),
            b.currSlide === f
              ? e.addClass(c).prop('disabled', !0)
              : e.removeClass(c).prop('disabled', !1);
        }
      }),
      a(document).on('cycle-destroyed', function (a, b) {
        b.API.getComponent('prev').off(b.nextEvent),
          b.API.getComponent('next').off(b.prevEvent),
          b.container.off(
            'swipeleft.cycle swiperight.cycle swipeLeft.cycle swipeRight.cycle swipeUp.cycle swipeDown.cycle'
          );
      });
  })(jQuery) /*! progressive loader plugin for Cycle2;  version: 20130315 */,
  (function (a) {
    'use strict';
    a.extend(a.fn.cycle.defaults, { progressive: !1 }),
      a(document).on('cycle-pre-initialize', function (b, c) {
        if (c.progressive) {
          var d,
            e,
            f = c.API,
            g = f.next,
            h = f.prev,
            i = f.prepareTx,
            j = a.type(c.progressive);
          if ('array' == j) d = c.progressive;
          else if (a.isFunction(c.progressive)) d = c.progressive(c);
          else if ('string' == j) {
            if (((e = a(c.progressive)), (d = a.trim(e.html())), !d)) return;
            if (/^(\[)/.test(d))
              try {
                d = a.parseJSON(d);
              } catch (k) {
                return void f.log('error parsing progressive slides', k);
              }
            else
              (d = d.split(new RegExp(e.data('cycle-split') || '\n'))),
                d[d.length - 1] || d.pop();
          }
          i &&
            (f.prepareTx = function (a, b) {
              var e, f;
              return a || 0 === d.length
                ? void i.apply(c.API, [a, b])
                : void (b && c.currSlide == c.slideCount - 1
                    ? ((f = d[0]),
                      (d = d.slice(1)),
                      c.container.one('cycle-slide-added', function (a, b) {
                        setTimeout(function () {
                          b.API.advanceSlide(1);
                        }, 50);
                      }),
                      c.API.add(f))
                    : b || 0 !== c.currSlide
                    ? i.apply(c.API, [a, b])
                    : ((e = d.length - 1),
                      (f = d[e]),
                      (d = d.slice(0, e)),
                      c.container.one('cycle-slide-added', function (a, b) {
                        setTimeout(function () {
                          (b.currSlide = 1), b.API.advanceSlide(-1);
                        }, 50);
                      }),
                      c.API.add(f, !0)));
            }),
            g &&
              (f.next = function () {
                var a = this.opts();
                if (d.length && a.currSlide == a.slideCount - 1) {
                  var b = d[0];
                  (d = d.slice(1)),
                    a.container.one('cycle-slide-added', function (a, b) {
                      g.apply(b.API), b.container.removeClass('cycle-loading');
                    }),
                    a.container.addClass('cycle-loading'),
                    a.API.add(b);
                } else g.apply(a.API);
              }),
            h &&
              (f.prev = function () {
                var a = this.opts();
                if (d.length && 0 === a.currSlide) {
                  var b = d.length - 1,
                    c = d[b];
                  (d = d.slice(0, b)),
                    a.container.one('cycle-slide-added', function (a, b) {
                      (b.currSlide = 1),
                        b.API.advanceSlide(-1),
                        b.container.removeClass('cycle-loading');
                    }),
                    a.container.addClass('cycle-loading'),
                    a.API.add(c, !0);
                } else h.apply(a.API);
              });
        }
      });
  })(jQuery) /*! tmpl plugin for Cycle2;  version: 20121227 */,
  (function (a) {
    'use strict';
    a.extend(a.fn.cycle.defaults, { tmplRegex: '{{((.)?.*?)}}' }),
      a.extend(a.fn.cycle.API, {
        tmpl: function (b, c) {
          var d = new RegExp(c.tmplRegex || a.fn.cycle.defaults.tmplRegex, 'g'),
            e = a.makeArray(arguments);
          return (
            e.shift(),
            b.replace(d, function (b, c) {
              var d,
                f,
                g,
                h,
                i = c.split('.');
              for (d = 0; d < e.length; d++)
                if ((g = e[d])) {
                  if (i.length > 1)
                    for (h = g, f = 0; f < i.length; f++)
                      (g = h), (h = h[i[f]] || c);
                  else h = g[c];
                  if (a.isFunction(h)) return h.apply(g, e);
                  if (void 0 !== h && null !== h && h != c) return h;
                }
              return c;
            })
          );
        },
      });
  })(jQuery);

//#endregion

//#region cycle 2 caption plugin

/* Plugin for Cycle2; Copyright (c) 2012 M. Alsup; v20141007 */
!(function (a) {
  'use strict';
  function b(b, c, d, e) {
    'caption2' === c.captionPlugin &&
      a.each(['caption', 'overlay'], function () {
        var a,
          b = this + 'Fx',
          f = c[b + 'Out'] || 'hide',
          g = d[this + 'Template'],
          h = c.API.getComponent(this),
          i = c[b + 'Sel'],
          j = c.speed;
        c.sync && (j /= 2),
          (a = i ? h.find(i) : h),
          h.length && g
            ? ('hide' == f && (j = 0),
              a[f](j, function () {
                var k = c.API.tmpl(g, d, c, e);
                h.html(k),
                  (a = i ? h.find(i) : h),
                  i && a.hide(),
                  (f = c[b + 'In'] || 'show'),
                  a[f](j);
              }))
            : h.hide();
      });
  }
  function c(b, c, d, e) {
    'caption2' === c.captionPlugin &&
      a.each(['caption', 'overlay'], function () {
        var a = d[this + 'Template'],
          b = c.API.getComponent(this);
        b.length && a && b.html(c.API.tmpl(a, d, c, e));
      });
  }
  a.extend(a.fn.cycle.defaults, {
    captionFxOut: 'fadeOut',
    captionFxIn: 'fadeIn',
    captionFxSel: void 0,
    overlayFxOut: 'fadeOut',
    overlayFxIn: 'fadeIn',
    overlayFxSel: void 0,
  }),
    a(document).on('cycle-bootstrap', function (a, d) {
      d.container.on('cycle-update-view-before', b),
        d.container.one('cycle-update-view-after', c);
    });
})(jQuery);

//#endregion

//#region old theme dependencies:

function smoothScroll() {
  const $link = $('.m-navigation a');

  if ($link.length) {
    $link.on('click', function (e) {
      e.preventDefault();

      const $this = $(this);

      let _elementId = $this.attr('href');

      _elementId = _elementId.replace('#', '');
      const element = document.getElementById(_elementId);

      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  }
}

function linkSmoothScroll() {
  const $link = $('a.m-smooth-scroll');

  if ($link.length) {
    $link.on('click', function (e) {
      e.preventDefault();

      const $this = $(this);

      let _elementId = $this.attr('href');

      _elementId = _elementId.replace('#', '');
      const element = document.getElementById(_elementId);

      element.scrollIntoView({
        behavior: 'smooth',
      });
    });
  }
}

function secondaryMenu() {
  const $hamburgerMenu = $('.l-mobile-hamburger-menu');

  if ($hamburgerMenu.length) {
    $hamburgerMenu.find('.icon').on('click', function () {
      const $this = $(this);

      $this
        .closest('.l-mobile-hamburger-menu')
        .toggleClass('is-opened')
        .next()
        .slideToggle();
    });
  }

  // menu item clicked:
  const $secondaryMenu = $('.m-menu-secondary');
  const intViewportWidth = window.innerWidth;

  if ($secondaryMenu.length) {
    $secondaryMenu.find('a').on('click', function (e) {
      e.preventDefault();

      const $this = $(this);
      let _elementId = $this.attr('href');

      _elementId = _elementId.replace('#', '');
      const element = document.getElementById(_elementId);

      element.scrollIntoView({
        behavior: 'smooth',
      });

      if (intViewportWidth < 990) {
        $secondaryMenu.slideToggle();
        $hamburgerMenu.toggleClass('is-opened');
      }
    });
  }
}

function lightboxConfig() {
  lightbox.option({
    alwaysShowNavOnTouchDevices: true,
    showImageNumberLabel: false,
  });
}

function _appendNewsletter() {
  const $newsletterPlaceholder = $('.l-newsletter-placeholder');
  const $newsletterColumn = $('.newl_des_3').clone(true);

  $newsletterColumn.appendTo($newsletterPlaceholder);
}

function _initiallyOpenFirst() {
  const $firstColumn = $('.footer_collapse_true .row .order-1');

  $firstColumn.find('.widget-title').trigger('click');
}

function footerMobile() {
  _appendNewsletter();
  _initiallyOpenFirst();
}

function featuredArtistsInit() {
  $('.m-featured')
    .find('img')
    .on('click', function () {
      const $this = $(this);
      const _href = $this.data('url');

      window.location.href = _href;
    });

  $('.m-featured')
    .find('.cycle-overlay')
    .on('click', function () {
      const $this = $(this);
      const $active_slide = $this
        .closest('.m-featured')
        .find('img.cycle-slide-active');
      const _href = $active_slide.data('url');

      window.location.href = _href;
    });

  $('.cycle-slideshow.l-second').cycle('pause');
  $('.cycle-slideshow.l-third').cycle('pause');

  setTimeout(function () {
    $('.cycle-slideshow.l-second').cycle('resume');
  }, 2000);

  setTimeout(function () {
    $('.cycle-slideshow.l-third').cycle('resume');
  }, 4000);
}

//#endregion

$(function () {
  const _is_featured_artists_cycle = true;

  smoothScroll();
  linkSmoothScroll();
  lightboxConfig();
  footerMobile();

  if (_is_featured_artists_cycle) {
    featuredArtistsInit();
  }
});

const customer_type_checkout = $('#customer-type--error').html();

geckoShopify.CustomerTypeCheckout = function () {
  if ($('.customer-type').length == 0) return;

  $('body').on(
    'click',
    '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
    function (e) {
      var frm = $(this).closest('form');

      if (
        frm.find('.customer-type').hasClass('required') &&
        frm.find('.customer-type option:selected').val() == ''
      ) {
        e.preventDefault();
        e.stopPropagation();
        geckoShopify.CreatNotices(customer_type_checkout);
      } else {
        $(this).submit();
      }
    }
  );
};

geckoShopify.CustomerTypeCheckout();
